import Metadata from '../../ServiceReqMetadata';
import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import InfoPopover from '../Common/InfoPopover';
// Removed unused imports (OverlayTrigger, Tooltip, Popover, Button, Spinner not required here)
import AddNewAccountableRepresentative from './AddNewAccountableRepresentative';
import ReplaceAnAccountableRepresentative from './ReplaceAnAccountableRepresentative';
// import ModiFyRegistrationDetails from './ModiFyRegistrationDetails';
import ModiFyRegistrationDetails_COPY from './ModiFyRegistrationDetails_COPY'; // Use the correct component name
import DeleteCompanyRecords from './DeleteCompanyRecords';
import './ManageCompany.css'

const ManageCompany = ({rqValue,company, requestSubType, confirmedRepId, usrExist,restrctFld}) => {
    const [requestSubTypeDisplayName, setRequestSubTypeDisplayName] = useState([]);
   const [selectedRequestTypeValue, setSelectedRequestTypeValue] = useState(requestSubType==="ReplaceCRep"?
   "Replace an accountable representative":'');
   const [popoverMsg, setPopoverMsg] = useState('');
   const handleSelectChange = (event) => {
    let selectedValue=event.target.value;
    var msg = Metadata.filter((record) => record.displayName === rqValue).map(
      (e) => {
        return e.requestSubTypes
          .filter((record) => record.displayName === selectedValue)
          .map((n) => {
            return n.whenToUse;
          });
      }
    );
    setPopoverMsg(msg);
    setSelectedRequestTypeValue(selectedValue);
  };
  const handleClearSelection = () => {
    setSelectedRequestTypeValue("");
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
 
   const customstyles = {
    dropdownindicator: base => ({
      ...base,
      fill: "red" // custom colour
    })
  };

  // Removed obsolete tooltip & popover helper definitions (InfoPopover now used)
 
    useEffect(() => {
        var requestSubTypes = Metadata.filter(record => record.displayName===rqValue) 
        .map((e) => {
           return e.requestSubTypes.map((n)=>{
            
            return n.displayName})
        } );
        setRequestSubTypeDisplayName(requestSubTypes);
        //console.log("ServiceReqMetadata::------->>"+Metadata.map((e) =>  e.requestType ));
        console.log("displayName....::------->>"+JSON.stringify(requestSubTypes));
        
          
        },[])
    return(
        <section className="serv-req-cre-manage-company mt-3 mb-3">
  <ul className="serv-req" id="serviceRequestDD">
    <li style={{
  opacity: (usrExist === 'false' || restrctFld === 'true') ? 0.60 : 1,
  pointerEvents: (usrExist === 'false' || restrctFld === 'true') ? 'none' : 'initial'
}}>
      <div className="drop-d-w">
        <div
          id="requestTypeDD"
          className="ui selection dropdown"
          tabIndex={1}
          style={{}}
        >
          <input type="hidden" name="selectSerReq" defaultValue />
          {selectedRequestTypeValue ? (
          <span 
            className="clear-icon-serviceRqstSubType"
            onClick={handleClearSelection}
          >
            &times;
          </span>
        ) : (
          <i className="dropdown icon" />
        )}

          <div>
          <Form.Select   
          defaultValue="Select Sub Type"
          value={selectedRequestTypeValue} styles={customstyles} style={{width:'100%'}} 
          onChange={handleSelectChange}  className={selectedRequestTypeValue ? 'dropdown-with-close' : 'dropdown-default'}>
      <option className="textdefault" value="">{"Select Sub Type"}</option>
        {requestSubTypeDisplayName[0] && requestSubTypeDisplayName[0].map((option, index) => (
          <option key={index} value={option}>{option}</option>
        ))}
      </Form.Select>
            {/* <select size={'lg'} defaultValue="Select Service Request"value={selectedRequestTypeValue} onChange={handleSelectChange}styles={customstyles} style={{width:'100%'}}>
<option className="textdefault" selected value={"Select Service Request"}>{"Select Service Request"}</option>
{requestTypeDisplayName.map((option, index) => (
<option key={index} value={option}>{option}</option>
))}
</select> */}
          </div>
        </div>
        <div className="col-sm-1">
        {popoverMsg!=''&&
        <InfoPopover
          id="manageCompanySubtypeInfo"
          className="info-icon-w ms-2"
          content={popoverMsg}
          ariaLabel="Information: sub type guidance"
        />
        }
        </div>
        
      </div>
    </li>
  </ul>
  <ul className="after-sel-sec serviceRequestFormBuilder">
    {/* to render different components on selection of select options */}
    <li>
                                  {selectedRequestTypeValue === "Modify Registration Details" && <ModiFyRegistrationDetails_COPY onCancel={handleClearSelection} />}
                                  {selectedRequestTypeValue === "Add new accountable representative" && <AddNewAccountableRepresentative rqValue={selectedRequestTypeValue} onCancel={handleClearSelection}/>}
                                  {selectedRequestTypeValue === "Replace an accountable representative" && <ReplaceAnAccountableRepresentative company={company} confirmedRepId={confirmedRepId} usrExist={usrExist} restrctFld={restrctFld} onCancel={handleClearSelection}/>}  
                                  {selectedRequestTypeValue === "Delete Company Records" && <DeleteCompanyRecords onCancel={handleClearSelection} />} 
                              </li>
  </ul>
</section>

            );
    }
    export default ManageCompany;